import React from 'react';
import Datepicker, { DatepickerProps } from '@/components/_common/Datepicker/Datepicker';
import { filterEmbargoMinAndMaxTime } from '@/_utils/date';
import { useTranslation } from 'react-i18next';

type EmbargoDatepickerProps = DatepickerProps & {
  dueDate?: string | Date;
};

const EmbargoDatepicker = ({ selected, dueDate, onChange, ...props }: EmbargoDatepickerProps) => {
  const { t } = useTranslation();
  const isEmbargoDateDisabled = !dueDate || new Date(dueDate).getTime() < Date.now();

  return (
    <Datepicker
      showTimeSelect
      disabled={isEmbargoDateDisabled}
      label={t('Embargo Date')}
      selected={selected}
      minDate={new Date()}
      maxDate={dueDate ? (typeof dueDate === 'string' ? new Date(dueDate) : dueDate) : undefined}
      filterTime={(selectedDate) => filterEmbargoMinAndMaxTime(selectedDate, dueDate)}
      onChange={onChange}
      popperProps={{ strategy: 'fixed' }}
      helperText={isEmbargoDateDisabled ? t('Embargo date cannot be in the past and before due date.') : undefined}
      {...props}
    />
  );
};

export default EmbargoDatepicker;
